// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"59c49a6a","424":"02c8b8c3","496":"491cabb7","504":"3b14d0a8","907":"3c7640ec"}[chunkId] + ".chunk.js";
};